module.exports = __webpack_public_path__ + "img/denmark-eye-and-ear-diseases-male.a0c22628.png";